const decorator = str => 'preorder/' + str;

export const LOAD_FEEDBACK_TROUBLES = decorator('LOAD_FEEDBACK_TROUBLES');
export const FEEDBACK_TROUBLES_LOADED = decorator('FEEDBACK_TROUBLES_LOADED');
export const FEEDBACK_TROUBLES_LOADED_WITH_ERROR = decorator('FEEDBACK_TROUBLES_LOADED_WITH_ERROR');
